import React, { useMemo } from 'react'
import { BarChart } from '@mui/x-charts/BarChart';
import { useMediaQuery } from '@mui/material';


function Dealer({ dealerBar, isDashboard, selectedCommonfilter }) {
    const userWiseData = dealerBar?.data?.userWiseData?.map(item => item.userName) || []
    const systemSize = dealerBar?.data?.userWiseData?.map(item => item.systemSize) || []
    const numberOfCustomer = dealerBar?.data?.userWiseData?.map(item => item.numberOfCustomer) || []

    const numberOfCustomerMonth = dealerBar?.data?.numberOfCustomer;
    const totalSystemSizeMonth = dealerBar?.data?.totalSystemSize;

    
    

    const getChartData = () => {
        if (!numberOfCustomerMonth || !totalSystemSizeMonth) return { countsnumberOfCustomer: [], countsSystemSize: [], labels: [] };

        const labels = Object.keys(numberOfCustomerMonth);
        const countsnumberOfCustomer = Object.values(numberOfCustomerMonth);
        const countsSystemSize = Object.values(totalSystemSizeMonth);
        return {
            countsnumberOfCustomer,
            countsSystemSize,
            labels: labels.map(label => selectedCommonfilter === "month" ? label.split(" ")[0] : label.split(" ")[0])
        };
    };
    const { countsnumberOfCustomer, countsSystemSize, labels } = getChartData();
    const isNarrowScreen = useMediaQuery('(max-width:920px)');

    return (
        <BarChart
            height={250}
            width={isNarrowScreen ? 1200 : 1700}
            xAxis={[
                {
                    data: selectedCommonfilter === "total" ? userWiseData : labels || [],
                    scaleType: 'band',
                    tickPlacement: 'middle',
                },
            ]}
            series={[
                {
                    data: selectedCommonfilter === "total" ? systemSize : countsSystemSize || [], 
                    label: "Total System Size"
                },
                {
                    data: selectedCommonfilter === "total" ? numberOfCustomer : countsnumberOfCustomer || [], 
                    label: "No. of Customer"
                },
            ]}
            
        />
    )
}

export default Dealer
